export default {
    clients: [],
    progress: {
        getAllClients: false,
        createClient: false,
        updateClient: false,
        deleteClient: false,
        createClientSpecialist: false,
        updateClientSpecialist: false,
        deleteClientSpecialist: false
    },
    errorMessagesByFields: {
        createClient: {},
        updateClient: {},
        createClientSpecialist: {},
        updateClientSpecialist: {}
    },
    //updateClientErrorMessagesByFields: {},
    availableReportSendModes: [
        {
            name: 'Manual',
            value: 'manual'
        },
        {
            name: 'Auto',
            value: 'auto'
        }
    ],
    availableDefaultSampleTargets: [
        {
            name: 'Analysis',
            value: 'analysis'
        },
        {
            name: 'Archive',
            value: 'archive'
        }
    ]
}